










































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable'
import { RepositoryFactory } from '@/api/RepositoryFactory';
import { log } from 'console';
import { ActuatorType } from '@/models/actuatorType';
import { MaintenanceListElementEntry } from '@/models/maintenanceListElementEntry';

@Component({
  components: {
    draggable

  }
})
export default class JunusComponentView extends Vue {


  private actuatorTypeRepository = RepositoryFactory.get('actuatorType');
  private maintenanceListElementEntryRepository = RepositoryFactory.get('maintenanceListElementEntry');
  private maintenanceListFormRepository = RepositoryFactory.get('maintenanceListForm');

  @Prop({ default: () => '' })
  public selectedActuatorTypeId!: string;

  @Prop({ default: () => [] })
  public allMaintenanceListElements!: any[];

  @Prop({ default: () => [] })
  public selectedMaintenanceListElements!: any;

  // Property to store maintenance list element entries
  public fetchedMaintenanceListElementEntries: MaintenanceListElementEntry[] = [];

  public selectedActuatorType: ActuatorType = new ActuatorType({});


  public selectedForm = 'function';

  public tab = 0;
  public tabItems = ['Zustand der Anlage', 'Funktion der Anlage'];

  public showConfirmDialog = false;

  public fetchedSelectedForm_entries: any[] = [];

  // Flag to prevent multiple simultaneous calls to updateLocalData
  private isUpdatingLocalData = false;

  public selectedElementEntry: MaintenanceListElementEntry | null = null;
  public selectedElementEntryName: string = '';

  @Watch('selectedForm')
  onSelectedFormChange(newVal: string) {
    if (this.selectedActuatorType && this.allMaintenanceListElements && this.allMaintenanceListElements.length > 0) {
      this.updateLocalData();
    }
  }

  @Watch('tab')
  onSelectedTabChange(newVal: string | number) {
    this.selectedForm = newVal === 0 ? 'condition' : 'function';

    if (this.selectedActuatorType && this.allMaintenanceListElements?.length) {
      this.updateLocalData();
    }
  }



  // Local data

  public localSelectedMaintenanceListElements: any[] = [];


  @Watch('selectedActuatorType', { immediate: true, deep: true })
  onSelectedActuatorTypeChange(newVal: any) {
    if (newVal && this.allMaintenanceListElements && this.allMaintenanceListElements.length > 0 && this.selectedForm) {
      this.updateLocalData();
    }
  }

  @Watch('selectedMaintenanceListElements', { deep: true })
  onSelectedObjectsChange(newVal: any[]) {
    // Skip if the value is empty or undefined (initial load)
    if (!newVal) {
      return;
    }


    // Filter out items that are already assigned as entries
    const selectedButNotAssigned = newVal.filter(item =>
      !this.fetchedMaintenanceListElementEntries.some(entry => {
        const entryElementId = typeof entry.maintenanceListElement === 'object'
          ? entry.maintenanceListElement.id
          : entry.maintenanceListElement;
        return entryElementId === item.id;
      })
    );

    // Update the local property with items that are selected but not yet assigned
    this.localSelectedMaintenanceListElements = selectedButNotAssigned;
  }

  @Watch('selectedActuatorTypeId', { immediate: true })
  onSelectedActuatorTypeIdChange(newVal: string) {
    if (newVal) {
      this.fetchActuatorData();
    }
  }

  public async mounted() {

    this.fetchActuatorData();
  }



  private async fetchActuatorData() {
    try {
      const response = await this.actuatorTypeRepository.getActuatorType(this.selectedActuatorTypeId);
      this.selectedActuatorType = response.data;

      // The watchers will handle updateLocalData when all required data is available
    } catch (error) {
      console.error(error);
    }
  }



  public async fetchMaintenanceListForm() {
    if (this.tab === 0) {
      this.selectedForm = 'condition';
    } else {
      this.selectedForm = 'function';
    }
    const response = await this.maintenanceListFormRepository.getFormByActuatorTypeAndFormType(this.selectedActuatorTypeId, this.selectedForm);
    return response.data;
  }


  public updateLocalChecklist(newVal: any) {
    console.log('updateLocalChecklist', newVal);
  }

  /**
   * This function is called when the defaultMaintenanceListElements changes
   * It fetches the maintenanceListForm and finds the matching entries
   * It emits the matchingIds to the parent component
   */
  public async updateLocalData() {
    if (this.isUpdatingLocalData) {
      // console.log('updateLocalData already in progress, skipping');
      return;
    }

    this.isUpdatingLocalData = true;
    // console.log('updateLocalData');

    try {
      this.fetchedSelectedForm_entries = await this.fetchMaintenanceListForm();
      this.fetchedMaintenanceListElementEntries = this.fetchedSelectedForm_entries[0]?.maintenanceListElementEntries || [];


      // Sort entries by order to maintain the correct sequence
      this.fetchedMaintenanceListElementEntries.sort((a, b) => {
        const orderA = a.order ?? 0;
        const orderB = b.order ?? 0;
        return orderA - orderB;
      });

      // Find matching entries - emit the maintenanceListElement IDs, not the entry IDs
      const matchingIds: string[] = [];
      for (let i = 0; i < this.allMaintenanceListElements.length; i++) {
        for (let j = 0; j < this.fetchedMaintenanceListElementEntries.length; j++) {
          const entryMaintenanceListElementId = typeof this.fetchedMaintenanceListElementEntries[j].maintenanceListElement === 'object'
            ? this.fetchedMaintenanceListElementEntries[j].maintenanceListElement.id
            : this.fetchedMaintenanceListElementEntries[j].maintenanceListElement;

          if (this.allMaintenanceListElements[i].id === entryMaintenanceListElementId) {
            matchingIds.push(entryMaintenanceListElementId);
          }
        }
      }

      this.$emit('check-chip-list', matchingIds);
    } finally {
      this.isUpdatingLocalData = false;
    }
  }

  public getLocalSelectedItemsIds() {
    // Use selectedObjects which contains the original database IDs
    return this.selectedMaintenanceListElements.map((obj: any) => obj.id);
  }

  public getLocalSelectedItemsObjects() {
    // Use selectedObjects directly since it already contains the correct objects
    return this.selectedMaintenanceListElements;
  }

  public async addMaintenanceListElementToEntryAndForm() {

    const selectedIds = this.localSelectedMaintenanceListElements.map(item => item.id);

    // Create entries for all selected items
    const createdEntries = [];

    for (let i = 0; i < selectedIds.length; i++) {
      const selectedId = selectedIds[i];
      try {
        // Calculate the order: existing entries count + current index
        const newOrder = this.fetchedMaintenanceListElementEntries.length + i;

        const entry = await this.maintenanceListElementEntryRepository.createItem({
          maintenanceListElement: selectedId,
          actuatorType: this.selectedActuatorType.id,
          formType: this.selectedForm,
          order: newOrder
        });
        createdEntries.push(entry);
      } catch (error) {
        console.error(`Failed to create entry for maintenanceListElement: ${selectedId}`, error);
      }
    }



    this.updateLocalData();
  }


  public elementEntryId: string = '';

  public openDeleteMaintenanceListElementEntryDialog(entry: any) {

    this.elementEntryId = entry.id;
    this.selectedElementEntry = entry;
    this.showConfirmDialog = true;
  }

  get deleteDialogText(): string {
  const entry = this.selectedElementEntry as MaintenanceListElementEntry;
  if (!entry) return '';

  let name = '';

  if (typeof entry.maintenanceListElement === 'object' && entry.maintenanceListElement?.name) {
    name = entry.maintenanceListElement.name;
  }

  return name ? `${name} löschen?` : 'Element löschen?';
}

  /**
   * Reorder all maintenance list element entries to have sequential order starting from 0
   * This is needed after deletion to fix gaps in the order sequence
   */
  public async reorderMaintenanceListElementEntries() {
    try {
      console.log('Starting reorder of maintenance list element entries');
      console.log('Current entries:', this.fetchedMaintenanceListElementEntries);

      // Update orders to be sequential (0, 1, 2, 3, ...)
      for (let i = 0; i < this.fetchedMaintenanceListElementEntries.length; i++) {
        const entry = this.fetchedMaintenanceListElementEntries[i];
        if (entry.id && entry.order !== i) {
          console.log(`Updating entry ${entry.id} from order ${entry.order} to ${i}`);
          try {
            await this.maintenanceListElementEntryRepository.updateItem(entry.id, { order: i });
            entry.order = i; // Update local state
          } catch (error) {
            console.error(`Failed to update order for entry ${entry.id}:`, error);
          }
        }
      }

      // Refresh data to ensure consistency
      await this.updateLocalData();
      console.log('Reorder completed');

    } catch (error) {
      console.error('Error reordering maintenance list element entries:', error);
      await this.updateLocalData();
    }
  }

  public async deleteMaintenanceListElementEntryConfirmed() {

    try {
      await this.maintenanceListElementEntryRepository.deleteItem(this.elementEntryId);

      // First refresh the data to get the updated list without the deleted entry
      await this.updateLocalData();

      // Then reorder the remaining entries to fix gaps in the sequence
      await this.reorderMaintenanceListElementEntries();

    } catch (error) {
      console.error(error);
    }
    this.showConfirmDialog = false;
  }

  public cancelConfirmDialog() {
    this.showConfirmDialog = false;
    this.elementEntryId = '';
  }

  /**
   * Called when drag and drop operation ends
   * Updates the order of entries and saves to backend
   */
  public async updateOrdersOfMainenanceListElementEntries() {
    // Update order based on current array position
    for (let i = 0; i < this.fetchedMaintenanceListElementEntries.length; i++) {
      const entry = this.fetchedMaintenanceListElementEntries[i];
      if (entry.id && entry.order !== i) {
        entry.order = i;

        try {
          await this.maintenanceListElementEntryRepository.updateItem(entry.id, {
            order: i
          });
        } catch (error) {
          console.error(`Failed to update order for entry ${entry.id}:`, error);
        }
      }
    }
  }


}
